import { useCallback, useMemo } from 'react';
// @ts-expect-error untyped dependency
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import UISideNav from 'UIComponents/nav/UISideNav';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import * as GROUPED_CATEGORIES from 'marketplace-ui-apps-core/common/constants/groupTags/SuperCategoryGroup';
import { getSuperCategoryI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import { SUPER_CATEGORY_ORDER } from 'marketplace-ui-apps-core/common/constants/groupTags/SuperCategoryOrder';
import { getCategoryI18nKey } from 'marketplace-ui-common/utils/i18n';
import * as FilterKey from '../../../../constants/search/FilterKey';
import { getFullHref } from '../../../../utils/history';
import { getAllCategoriesUrl, getSuperCategoryFilterUrl, getCategoryFilterUrl } from '../../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ALL_CATEGORIES_VALUE = '__ALL_CATEGORIES__';
function getSuperCategoryCategories(superCategory) {
  return superCategory in GROUPED_CATEGORIES ? GROUPED_CATEGORIES[superCategory] : [];
}
function getSideNavItemValue(superCategory, category) {
  return [superCategory, category].filter(Boolean).join(':');
}
function renderSuperCategoryNavItem({
  active,
  isAdminPreview,
  onCategoryClick,
  superCategory
}) {
  const categories = getSuperCategoryCategories(superCategory);
  return /*#__PURE__*/_jsxs(UISideNavItem, {
    defaultOpen: active,
    disabled: isAdminPreview,
    title: unescapedText(getSuperCategoryI18nKey(superCategory)),
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      href: getFullHref(getSuperCategoryFilterUrl(superCategory)),
      onClick: event => onCategoryClick(event, superCategory),
      title: unescapedText('appMarketplace.storefront.filters.category.allSuperCategoryTitleText', {
        superCategory: unescapedText(getSuperCategoryI18nKey(superCategory))
      }),
      value: getSideNavItemValue(superCategory)
    }), categories.map(category => [category, unescapedText(getCategoryI18nKey(category))]).sort(([__categoryA, categoryATitle], [__categoryB, categoryBTitle]) => localeComparator(categoryATitle, categoryBTitle)).map(([category, categoryTitle]) => /*#__PURE__*/_jsx(UISideNavItem, {
      href: getFullHref(getCategoryFilterUrl(category, superCategory)),
      onClick: event => onCategoryClick(event, superCategory, category),
      title: categoryTitle,
      value: getSideNavItemValue(superCategory, category)
    }, `category-nav-item-${superCategory}-${category}`))]
  }, `super-category-nav-item-${superCategory}`);
}
export default function CategoryNav({
  activeCategory,
  activeSuperCategory,
  isAdminPreview,
  isAllCategories,
  onCategoryClick,
  trackFilterNavItemClick
}) {
  const handleCategoryClick = useCallback((event, superCategory, category) => {
    event.preventDefault();
    if (!isAdminPreview) {
      onCategoryClick(superCategory, category);
      if (category) {
        trackFilterNavItemClick(FilterKey.CATEGORY, category);
      } else if (superCategory) {
        trackFilterNavItemClick(FilterKey.SUPER_CATEGORY, superCategory);
      } else {
        trackFilterNavItemClick(FilterKey.SUPER_CATEGORY, 'all categories');
      }
    }
  }, [isAdminPreview, onCategoryClick, trackFilterNavItemClick]);
  const renderedSuperCategoryNavItems = useMemo(() => {
    return SUPER_CATEGORY_ORDER.map(superCategory => renderSuperCategoryNavItem({
      active: superCategory === activeSuperCategory,
      isAdminPreview,
      onCategoryClick: handleCategoryClick,
      superCategory
    }));
  }, [activeSuperCategory, handleCategoryClick, isAdminPreview]);
  return /*#__PURE__*/_jsxs(UISideNav, {
    "aria-label": unescapedText('appMarketplace.storefront.filters.category.titleText'),
    value: isAllCategories ? ALL_CATEGORIES_VALUE : getSideNavItemValue(activeSuperCategory, activeCategory),
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      disabled: isAdminPreview,
      href: getFullHref(getAllCategoriesUrl()),
      onClick: handleCategoryClick,
      title: unescapedText('appMarketplace.storefront.filters.category.items.all.titleText'),
      value: ALL_CATEGORIES_VALUE
    }), renderedSuperCategoryNavItems]
  });
}